import { EmailType } from 'src/models/User'
import { get, post } from './axios'
import { GetAccountTransferEditParamsResponseData } from './paymentMethods'

//////////////////////////////////////////////////////////////////////
// GET
//////////////////////////////////////////////////////////////////////

/**
 * getAccountTransferEditParams
 */

export type GetAccountTransferEditParamsParams = {
  appId: number
  accessToken: string
}

export const getAccountTransferEditParams = async ({ appId, accessToken }: GetAccountTransferEditParamsParams) => {
  return await get<GetAccountTransferEditParamsResponseData>(
    `/v1/webApplications/${appId}/accountTransferEditParams`,
    { accessToken },
    false,
  )
}

/**
 * getCreditCardEditURL
 */

export type GetCreditCardEditURLParams = {
  appId: number
  accessToken: string
}

export const getCreditCardEditURL = async ({ appId, accessToken }: GetCreditCardEditURLParams) => {
  return await get<{ url: string }>(`/v1/webApplications/${appId}/creditCardEditURL`, { accessToken }, false)
}

//////////////////////////////////////////////////////////////////////
// POST
//////////////////////////////////////////////////////////////////////

/**
 * register
 */

export type RegisterParams = {
  buildingId: number
  roomId: number

  firstName: string
  lastName: string
  firstNameKana: string
  lastNameKana: string
  phoneNumber: string
  email: string
  emailType: EmailType
  moveInOn: string // yyyy-MM-dd

  emergencyContactFirstName?: string | null
  emergencyContactLastName?: string | null
  emergencyContactFirstNameKana?: string | null
  emergencyContactLastNameKana?: string | null
  emergencyContactPhoneNumber?: string | null
  emergencyContactRelationship?: string | null

  payerFirstName?: string | null
  payerLastName?: string | null
  payerFirstNameKana?: string | null
  payerLastNameKana?: string | null
}

export const CreationResult = {
  Success: '000', // 申し込み完了
  CheckRequired: '001', // 確認が必要（申し込みは完了）
  AlreadyApplied: '100', // すでに申し込み済み
  AlreadySignedUp: '101', // すでに入居済み
} as const
export type CreationResult = (typeof CreationResult)[keyof typeof CreationResult]

export type RegisteredInfo =
  | {
      result: typeof CreationResult.Success
      info: {
        appId: number
        accessToken: string
      }
    }
  | {
      result: Exclude<CreationResult, typeof CreationResult.Success>
      message: string
    }

type RegisterResponseData = {
  info: RegisteredInfo
}

export const register = async (params: RegisterParams) => {
  return await post<RegisterResponseData>('/v1/webApplications', params, false)
}
